/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Do not sell or share my personal information",
      "Bumble Date",
      "Our apps",
      "About",
      "Careers",
      "Contact us",
      "Investors",
      "The Shop",
      "Company",
      "Download the app",
      "Accessibility at Bumble",
      "Guidelines",
      "Manage cookies",
      "Modern Slavery act",
      "Notice at collection",
      "Privacy policy",
      "Terms and conditions",
      "Legal",
      "Washington Consumer Health Privacy Policy",
      "Scan the QR code to get the Bumble app",
      "Terminate contracts here",
      "Close menu",
      "Open menu",
      "Language selection",
      "Footer",
      "Accessibility at Bumble",
      "Apple and the Apple logo are trademarks of Apple Inc.",
      "Bumble BFF",
      "Bumble Bizz",
      "Bumble Date",
      "Careers",
      "Google Play is a trademark of Google LLC.",
      "Guidelines",
      "Investors",
      "Manage Cookies",
      "Modern Slavery Act Statement",
      "Notice At Collection",
      "Privacy Policy",
      "Seasonal Dating Guides",
      "Terms & Conditions",
      "The app",
      "Washington Consumer Health Data Privacy Policy",
      "About",
      "Ambassadors",
      "Make new friends and find your community",
      "Network professionally and make career moves",
      "Find a relationship, something casual, or anything in-between",
      "The Buzz",
      "Find out more",
      "Go global with Travel Mode",
      "Date",
      "Features",
      "Compliments",
      "Throw some Compliments their way so you stand out from the crowd.",
      "Discover",
      "A personalized page that highlights your most compatible people, refreshed daily.",
      "Incognito Mode",
      "Use Incognito Mode to hide your profile from your boss, relatives, or exes.",
      "Instant Match",
      "Started the conversation at a Bumble IRL event? Keep it going on the app.",
      "Opening Moves",
      "Choose Opening Moves to invite your match to start the chat, so you don’t have to.",
      "Snooze mode",
      "Put dating on hold with Snooze Mode. When you’re ready to date again, you know where we are.",
      "SuperSwipe",
      "Profile passed the vibe check? Let them know with a SuperSwipe.",
      "Travel mode",
      "Find your duty-free snack and match anywhere in the world with Travel Mode.",
      "Video chat",
      "Use video chat and audio calls to see if you’re ready to meet in person.",
      "Web app",
      "Get the Bumble experience straight from your browser.",
      "Get the Bumble app",
      "BFF",
      "Safety",
      "Stories",
      "Support",
      "The Shop",
      "Main",
      "Throw some Compliments their way so you stand out.",
      "Compliments",
      "Features designed to create space for real, respectful, and meaningful connections.",
      "Hide your profile from your boss, relatives, or exes.",
      "Incognito Mode",
      "Put dating on hold with Snooze Mode.",
      "Snooze mode",
      "Seen someone you like? Let them know.",
      "SuperSwipe",
      "Explore Date",
      "Find your duty-free snack and match anywhere.",
      "Travel mode",
      "Get as close to IRL without leaving your house.",
      "Video Calls",
      "Our leaders help bring Bumble’s values into their communities across the country.",
      "Community Leaders",
      "Features designed to help you find your people and connect over what you're into.",
      "Organize a group meetup, or discover local events happening nearby.",
      "Plans",
      "Explore BFF",
      "All the guidance and inspiration you need to help you find love and friendship.",
      "Advice and stories to help you build the friendships you want.",
      "The Friendship Hub",
      "From Tokyo to Toronto, explore the love found on Bumble around the world.",
      "Love Stories",
      "Plan the perfect date—no matter when, where or who you're dating.",
      "Seasonal Dating Guides",
      "Explore Stories",
      "Read more",
      "Bumble on {{social_network}}",
      "Contact us",
      "Sign In",
      "(opens in new window)",
      "FAQ",
      "Cookie Policy",
      "Bumble - The Blog",
      "Careers",
      "Chat",
      "Cities",
      "Manage cookies",
      "Copyright © 2006 – present. Bumble. All rights reserved.",
      "Dating Confidence Report",
      "Apple and the Apple logo are trademarks of Apple Inc.{{__EOL__}}Google Play is a trademark of Google LLC.",
      "Download",
      "Facebook",
      "Follow us",
      "Help Center",
      "Instagram",
      "Language",
      "LinkedIn",
      "Bumble is part of Bumble Inc.",
      "Privacy policy",
      "Safety Center",
      "Sitemap",
      "Modern Slavery Act statement",
      "Terms and conditions",
      "Twitter"
],

    // These are the common words found in the lexemes of the app
    common: {
      "day": {
            "plural": [
                  "days"
            ],
            "singular": [
                  "day"
            ]
      },
      "hour": {
            "plural": [
                  "hours"
            ],
            "singular": [
                  "hour"
            ]
      },
      "minute": {
            "plural": [
                  "minutes"
            ],
            "singular": [
                  "minute"
            ]
      },
      "month": {
            "plural": [
                  "months"
            ],
            "singular": [
                  "month"
            ]
      },
      "second": {
            "plural": [
                  "seconds"
            ],
            "singular": [
                  "second"
            ]
      },
      "year": {
            "plural": [
                  "years"
            ],
            "singular": [
                  "year"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
